import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'authority'
})
export class AuthorityPipe implements PipeTransform {
    transform(value) {
        if (value) {
            let authorities = '';
            for (let i = 0; i < value.length; i++) {
                authorities = value[i] + ' , ' + authorities;
            }
            return authorities.substring(0, authorities.length - 2);
        } else {
            return '';
        }
    }
}
